import Vue from 'vue';
import Component from 'vue-class-component';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class DialogSbpQrComponent extends Vue {
    qrUrl: string = '';
    showReturnLink: boolean = false;
    showDialog: boolean = false;
    
    show(qrUrl: string, showReturnLink: boolean = false) {
        this.qrUrl = qrUrl;
        this.showReturnLink = showReturnLink;
        this.showDialog = true;
    }
    
    close() {
        this.showDialog = false;
        this.$emit('close');
    }
}
